export default __webpack_public_path__ + "static/media/hiringArrowDown.c8610e00.svg";